import { combineReducers } from "redux";
import ProfileReducer from "./LoginReducer";

export const reducers = combineReducers({
    login: ProfileReducer,

})

